// Theme: bitcrush-sunset
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'bitcrush-sunset',
  name: 'BITCRUSH SUNSET',
  tagline: 'BITCRUSH SUNSET',
  description: 'Por do sol 8-bit com textura pixelada e dithering controlado.',
  category: 'retro-memory',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0F0808', '#FB7185', '#2A1510', '#FED7AA'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-mono theme-bitcrush-sunset'
  },
  colorVars: {
    '--accent': '#FB7185',
    '--accent-foreground': '#0F0808',
    '--background': '#0F0808',
    '--border': '#C05A30',
    '--card': '#2A1510',
    '--card-border-active': 'rgba(251, 113, 133, 0.48)',
    '--card-completed': '#2A1510',
    '--card-foreground': '#FED7AA',
    '--card-glow': 'rgba(251, 113, 133, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0F0808',
    '--foreground': '#FED7AA',
    '--hold-fill': '#FB7185',
    '--input': '#2A1510',
    '--modal-bg': '#0F0808',
    '--modal-border': '#C05A30',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C05A30',
    '--muted-foreground': '#FED7AA',
    '--nav-active': '#FB7185',
    '--nav-bg': '#0F0808',
    '--popover': '#2A1510',
    '--popover-foreground': '#FED7AA',
    '--primary': '#FB7185',
    '--primary-foreground': '#0F0808',
    '--ring': '#FB7185',
    '--secondary': '#C05A30',
    '--secondary-foreground': '#FED7AA',
    '--streak': '#FB7185',
    '--success': '#22C55E',
    '--success-foreground': '#0F0808',
    '--xp': '#FB7185',
    '--xp-bg': '#2A1510'
  },
  resolvedVars: {
    '--accent': '#FB7185',
    '--accent-foreground': '#0F0808',
    '--accent-foreground-hsl': '0 30% 5%',
    '--accent-foreground-oklch': 'from #0F0808 l c h',
    '--accent-hsl': '351 95% 71%',
    '--accent-oklch': 'from #FB7185 l c h',
    '--background': '#0F0808',
    '--background-hsl': '0 30% 5%',
    '--background-oklch': 'from #0F0808 l c h',
    '--border': '#C05A30',
    '--border-hsl': '18 60% 47%',
    '--border-oklch': 'from #C05A30 l c h',
    '--border-w': '1px',
    '--card': '#2A1510',
    '--card-border-active': 'rgba(251, 113, 133, 0.48)',
    '--card-completed': '#2A1510',
    '--card-completed-hsl': '12 45% 11%',
    '--card-completed-oklch': 'from #2A1510 l c h',
    '--card-foreground': '#FED7AA',
    '--card-foreground-hsl': '32 98% 83%',
    '--card-foreground-oklch': 'from #FED7AA l c h',
    '--card-glow': 'rgba(251, 113, 133, 0.1)',
    '--card-hsl': '12 45% 11%',
    '--card-oklch': 'from #2A1510 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0F0808',
    '--destructive-foreground-hsl': '0 30% 5%',
    '--destructive-foreground-oklch': 'from #0F0808 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#FED7AA',
    '--foreground-hsl': '32 98% 83%',
    '--foreground-oklch': 'from #FED7AA l c h',
    '--hold-fill': '#FB7185',
    '--hold-fill-hsl': '351 95% 71%',
    '--hold-fill-oklch': 'from #FB7185 l c h',
    '--input': '#2A1510',
    '--input-hsl': '12 45% 11%',
    '--input-oklch': 'from #2A1510 l c h',
    '--modal-bg': '#0F0808',
    '--modal-bg-hsl': '0 30% 5%',
    '--modal-bg-oklch': 'from #0F0808 l c h',
    '--modal-border': '#C05A30',
    '--modal-border-hsl': '18 60% 47%',
    '--modal-border-oklch': 'from #C05A30 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#C05A30',
    '--muted-foreground': '#FED7AA',
    '--muted-foreground-hsl': '32 98% 83%',
    '--muted-foreground-oklch': 'from #FED7AA l c h',
    '--muted-hsl': '18 60% 47%',
    '--muted-oklch': 'from #C05A30 l c h',
    '--nav-active': '#FB7185',
    '--nav-active-hsl': '351 95% 71%',
    '--nav-active-oklch': 'from #FB7185 l c h',
    '--nav-bg': '#0F0808',
    '--nav-bg-hsl': '0 30% 5%',
    '--nav-bg-oklch': 'from #0F0808 l c h',
    '--popover': '#2A1510',
    '--popover-foreground': '#FED7AA',
    '--popover-foreground-hsl': '32 98% 83%',
    '--popover-foreground-oklch': 'from #FED7AA l c h',
    '--popover-hsl': '12 45% 11%',
    '--popover-oklch': 'from #2A1510 l c h',
    '--primary': '#FB7185',
    '--primary-foreground': '#0F0808',
    '--primary-foreground-hsl': '0 30% 5%',
    '--primary-foreground-oklch': 'from #0F0808 l c h',
    '--primary-hsl': '351 95% 71%',
    '--primary-oklch': 'from #FB7185 l c h',
    '--radius': '12px',
    '--ring': '#FB7185',
    '--ring-hsl': '351 95% 71%',
    '--ring-oklch': 'from #FB7185 l c h',
    '--secondary': '#C05A30',
    '--secondary-foreground': '#FED7AA',
    '--secondary-foreground-hsl': '32 98% 83%',
    '--secondary-foreground-oklch': 'from #FED7AA l c h',
    '--secondary-hsl': '18 60% 47%',
    '--secondary-oklch': 'from #C05A30 l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#FB7185',
    '--streak-hsl': '351 95% 71%',
    '--streak-oklch': 'from #FB7185 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#0F0808',
    '--success-foreground-hsl': '0 30% 5%',
    '--success-foreground-oklch': 'from #0F0808 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(351 95% 71% / 0.15)',
    '--xp': '#FB7185',
    '--xp-bg': '#2A1510',
    '--xp-bg-hsl': '12 45% 11%',
    '--xp-bg-oklch': 'from #2A1510 l c h',
    '--xp-hsl': '351 95% 71%',
    '--xp-oklch': 'from #FB7185 l c h'
  }
}
